<template>
  <div class="scrolling-text-container" style="font-size: 14px;color: #606266;">
    <div class="scrolling-text" :style="{
      animationDuration: `${speed}s`,
    }">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: "ScrollingText",
  props: {
    text: {
      type: String,
      default: '这是一段需要水平滚动的长文本内容...'
    },
    speed: {
      type: Number,
      default: 15
    }
  },
}
</script>

<style lang="scss" scoped>
.scrolling-text-container {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  // color: #f00;
}

.scrolling-text {
  display: inline-block;
  padding-left: 100%;
  animation: scroll 15s linear infinite;
}

@keyframes scroll {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-100%);
  }
}
</style>